import React from "react";
import CompanySolutionsPage from "@components/Pages/CompanySolutionsPage/CompanySolutionsPage";

export default function Software() {
    return <CompanySolutionsPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
